<template>
  <section id="dashboard" class="fill-height">
    <v-container class="fill-height">
      <v-row>
        <v-col cols="12">
          <v-card class="shadow-5">
            <v-card-title
              class="title text--primary"
              style="word-break: normal; line-height: normal;"
            >
              Clientes
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="auto">
                  <v-chip class="ma-2" color="transparent" label>
                    <v-icon x-large color="success" left>
                      mdi-circle-small
                    </v-icon>
                    Activos: {{ dashboard_client.count_client[0].enable }}
                  </v-chip>
                </v-col>
                <v-col cols="auto">
                  <v-chip class="ma-2" color="transparent" label>
                    <v-icon x-large color="error" left>
                      mdi-circle-small
                    </v-icon>
                    Inactivos: {{ dashboard_client.count_client[0].disabled }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="shadow-5">
            <v-card-text>
              <v-data-table
                dense
                :headers="dashboard_client_headers"
                :items="dashboard_client.client_users"
                :items-per-page="50"
                :footer-props="{
                  'items-per-page-options': [50, 100, 150, -1],
                }"
              >
                <template v-slot:[`item.entered`]="{ item }">
                  {{ item.report_data.entered || 0 }}
                </template>
                <template v-slot:[`item.replied`]="{ item }">
                  {{ item.report_data.replied || 0 }}
                </template>
                <template v-slot:[`item.abandoned`]="{ item }">
                  {{ item.report_data.abandoned || 0 }}
                </template>
                <template v-slot:[`item.efficiency`]="{ item }">
                  {{ item.report_data.efficiency || 0 }} %
                </template>
                <template v-slot:[`item.average_wait`]="{ item }">
                  {{ item.report_data.average_wait || 0 }} seg
                </template>
                <template v-slot:[`item.average_conversation`]="{ item }">
                  {{ item.report_data.average_conversation || 0 }} seg
                </template>
                <template v-slot:[`item.average_abandonment`]="{ item }">
                  {{ item.report_data.average_abandonment || 0 }} seg
                </template>
                <template v-slot:[`item.attendedtransfer`]="{ item }">
                  {{ item.report_data.attendedtransfer || 0 }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services";

export default {
  inject: ["theme"],

  data() {
    return {
      userData: {},
      totalOutgoingCalls: 0,
      totalIncomingCalls: 0,
      dashboard_client_headers: [
        { text: "Cliente", value: "name", class: "primary--text" },
        { text: "Ingresadas", value: "entered", class: "primary--text" },
        { text: "Contestadas", value: "replied", class: "primary--text" },
        { text: "Abandonadas", value: "abandoned", class: "primary--text" },
        { text: "Eficiencia", value: "efficiency", class: "primary--text" },
        { text: "Espera", value: "average_wait", class: "primary--text" },
        {
          text: "Conversacion",
          value: "average_conversation",
          class: "primary--text",
        },
        {
          text: "Abandono",
          value: "average_abandonment",
          class: "primary--text",
        },
        {
          text: "Transferidas",
          value: "attendedtransfer",
          class: "primary--text",
        },
      ],
      dashboard_client: [],
    };
  },

  mounted() {
    this.userData = JSON.parse(localStorage.getItem("user"));
    this.getQueueDashboard();
  },

  methods: {
    async getQueueDashboard() {
      try {
        const { data } = await PbxHttpClient.get("/reportDashboardCombined");
        this.dashboard_client = data;
      } catch (error) {
        // console.error("Error de recordings", error);
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
    },
  },
};
</script>
